var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9528_107344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.338778 7.90354C0.338406 9.24785 0.689662 10.5605 1.35757 11.7174L0.274902 15.6704L4.3203 14.6097C5.4392 15.2188 6.69285 15.538 7.96681 15.5381H7.97016C12.1757 15.5381 15.5992 12.1159 15.601 7.90956C15.6018 5.8713 14.8087 3.95465 13.3679 2.51266C11.9272 1.0708 10.0113 0.276321 7.96985 0.275391C3.76377 0.275391 0.340577 3.69741 0.33884 7.90354",
    fill: "url(#paint0_linear_9528_107344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0663566 7.90177C0.0659225 9.29445 0.429767 10.654 1.12149 11.8524L0 15.9471L4.19045 14.8484C5.34505 15.4779 6.64502 15.8098 7.96781 15.8103H7.97122C12.3277 15.8103 15.8741 12.265 15.876 7.90809C15.8767 5.79659 15.0551 3.81104 13.5628 2.3174C12.0703 0.823938 10.0858 0.000868217 7.97122 0C3.61402 0 0.068093 3.54481 0.0663566 7.90177ZM2.56186 11.646L2.4054 11.3976C1.74766 10.3518 1.4005 9.14325 1.40099 7.90226C1.40242 4.28087 4.34964 1.33457 7.97371 1.33457C9.72874 1.33532 11.3781 2.01947 12.6187 3.26077C13.8592 4.5022 14.5418 6.15243 14.5413 7.9076C14.5397 11.529 11.5924 14.4757 7.97122 14.4757H7.96862C6.78952 14.475 5.63312 14.1584 4.62462 13.56L4.38462 13.4177L1.89792 14.0696L2.56186 11.646V11.646Z",
    fill: "url(#paint1_linear_9528_107344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99552 4.59782C5.84755 4.26895 5.69183 4.26232 5.55112 4.25655C5.43589 4.25159 5.30417 4.25196 5.17257 4.25196C5.04085 4.25196 4.82684 4.30151 4.64594 4.49903C4.46485 4.69673 3.95459 5.1745 3.95459 6.14622C3.95459 7.11801 4.66237 8.05711 4.76104 8.18901C4.85983 8.32067 6.12743 10.3786 8.13499 11.1703C9.80346 11.8282 10.143 11.6974 10.5051 11.6644C10.8673 11.6315 11.6737 11.1867 11.8382 10.7255C12.0029 10.2644 12.0029 9.86908 11.9535 9.78647C11.9042 9.70418 11.7725 9.65475 11.5749 9.55602C11.3773 9.45723 10.4063 8.9794 10.2253 8.91348C10.0442 8.84762 9.91254 8.81475 9.78082 9.01252C9.6491 9.20998 9.27087 9.65475 9.15558 9.78647C9.04042 9.9185 8.92513 9.93494 8.72767 9.83615C8.53003 9.73705 7.89394 9.52873 7.13927 8.85593C6.55211 8.33239 6.15571 7.68588 6.04048 7.48811C5.92526 7.29066 6.02814 7.18362 6.12718 7.0852C6.21592 6.9967 6.32476 6.85456 6.42361 6.73928C6.52209 6.62393 6.55496 6.54163 6.62082 6.40991C6.68675 6.27807 6.65375 6.16272 6.60445 6.06393C6.55496 5.96514 6.17115 4.98833 5.99552 4.59782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9528_107344",
    x1: 766.579,
    y1: 1539.78,
    x2: 766.579,
    y2: 0.275391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9528_107344",
    x1: 793.798,
    y1: 1594.71,
    x2: 793.798,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9528_107344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.876,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bbb1736dbc680cb072c657589a250a5a.svg";
export { ForwardRef as ReactComponent };